import { ExpiringBanksList } from "Components/Banking/Auth/ExpiringBanksList";
import { useBankingPispAuth } from "Hooks/useBankingPispAuth";
import type { BankEnvironment } from "Infrastructure/Api/Api";

type Props = {
  environments: Array<BankEnvironment>;
};

export const ExpiringPispBanksList = ({ environments }: Props) => {
  const { authorize, isPending, selectedEnvironment } = useBankingPispAuth();

  return (
    <ExpiringBanksList
      environments={environments}
      authorize={authorize}
      isPending={isPending}
      selectedEnvironment={selectedEnvironment}
    />
  );
};
